<template>
  <div class="home-skeleton">
    <!-- ряд категорій -->
    <div class="sk-category-row">
      <div v-for="n in 6" :key="'cat' + n" class="skeleton sk-chip"></div>
    </div>

    <!-- банер -->
    <div class="skeleton sk-banner"></div>

    <!-- секції товарів -->
    <div v-for="s in 2" :key="'sec' + s" class="sk-section">
      <div class="sk-section-header">
        <div class="skeleton sk-section-title"></div>
        <div class="skeleton sk-section-link"></div>
      </div>
      <div class="sk-cards">
        <div v-for="n in cardsPerRow" :key="'card' + s + n" class="sk-card">
          <div class="skeleton sk-card-image"></div>
          <div class="sk-card-body">
            <div class="skeleton sk-line sk-line-wide"></div>
            <div class="skeleton sk-line sk-line-narrow"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home-skeleton",
  data() {
    return {
      cardsPerRow: window.innerWidth >= 1024 ? 5 : 2,
    };
  },
};
</script>

<style scoped>
.home-skeleton {
  padding: 16px;
}

.sk-category-row {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  overflow: hidden;
}
.sk-chip {
  flex: 0 0 auto;
  width: 70px;
  height: 32px;
  border-radius: 16px;
}

.sk-banner {
  width: 100%;
  height: clamp(104px, 22vh, 160px);
  border-radius: 12px;
  margin-top: 16px;
}

.sk-section {
  margin-top: 24px;
}
.sk-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.sk-section-title {
  width: 45%;
  height: 22px;
  border-radius: 6px;
}
.sk-section-link {
  width: 70px;
  height: 16px;
  border-radius: 6px;
}

.sk-cards {
  display: flex;
  gap: 12px;
}
.sk-card {
  flex: 1 1 0;
  border-radius: 10px;
  border: 2px solid #e5e7eb;
  background: #f3f4f6;
  overflow: hidden;
}
.sk-card-image {
  width: 100%;
  height: 140px;
}
.sk-card-body {
  padding: 7px;
}
.sk-line {
  height: 11px;
  border-radius: 4px;
  margin-bottom: 6px;
}
.sk-line-wide {
  width: 90%;
}
.sk-line-narrow {
  width: 50%;
  margin-bottom: 0;
}

@media (min-width: 1024px) {
  .home-skeleton {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0;
  }
  .sk-banner {
    height: clamp(140px, 25vh, 240px);
  }
  .sk-card-image {
    height: 200px;
  }
}
</style>
